<template>
    <div class="defenseSession">
      <div class="cont-box">
        <div class="title">
          <Title text="毕业答辩" />
          <div>
            <el-form
              ref="search"
              :inline="true"
              :model="condition"
              :rules="searchRules"
              class="search-form"
              slot="search"
              label-width="80px"
            >
              <div style="display: flex; justify-content: space-between">
                <div>
                  <div>
                    <el-form-item prop="paper_plan_student_id">
                      <el-select
                        v-model="condition.paper_plan_student_id"
                        placeholder="请选择论文计划"
                        clearable
                        filterable
                        style="width: 300px;"
                      >
                        <el-option
                          v-for="item in thesisPlanList"
                          :key="item.id"
                          :label="item.title"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="loadData">确认</el-button>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </el-form>
          </div>
        </div>
        <div>
          <el-table
            :data="list"
            headerRowClassName="uni-primary-table-header"
            stripe
            border
          >
            <el-table-column prop="plan_title" align="center" label="计划"></el-table-column>
            <el-table-column prop="defense_start_at" align="center" label="答辩开始时间">
<!--                <template slot-scope="{row}">-->
<!--                    <span>{{ row.defense_start_at }} - {{ row.defense_end_at }}</span>-->
<!--                </template>-->
            </el-table-column>
            <el-table-column prop="defense_address" align="center" label="答辩地点"></el-table-column>
            <el-table-column prop="group_title" align="center" label="答辩组"></el-table-column>
            <el-table-column prop="reply_teacher_titles" align="center" label="答辩组教师"></el-table-column>
            <el-table-column prop="defence_sort" align="center" label="答辩序号"></el-table-column>
            <el-table-column prop="process_status_title" align="center" label="状态"></el-table-column>

            <!-- <el-table-column align="center" label="操作" width="200">
              <template slot-scope="{row}">
                <el-button
                  class="link-btn"
                  type="text"
                  @click="submitForm(row)"
                >提交答辩情况记录表</el-button>
              </template>
            </el-table-column> -->
          </el-table>
        </div>
      </div>
    </div>
  </template>

  <script>
  import {
    adultStudentPpAll,
    studentPpsGetReply,
  } from "@/api/graduation";
  import { putObject, uploadFiles, deleteObject } from "@/utils/upload";

  export default {
    name: "defenseSession",
    data() {
      return {
        condition: {
          paper_plan_student_id: '',  //论文计划
        },
        searchRules: {
          paper_plan_student_id: [{ required: true, message: "请选择论文计划", trigger: "change" }],
        },
        thesisPlanList: [],  //论文计划列表

        list:[],
        listTotal: -1,

      };
    },
    created() {
      // this.getListFn();
      this.getThesisPlanList();
    },
    methods: {
        // 选择资料确认
        loadData(){
        this.$refs["search"].validate((valid) => {
            if (valid) {
                this.getListFn();
            }
        });
        },
      // 获取论文计划
      getThesisPlanList(){
        adultStudentPpAll().then(res => {
          this.thesisPlanList = res.result;
        });
      },
      // 获取数据
      getListFn(){
        let data = {
          paper_plan_student_id: this.condition.paper_plan_student_id
        };
        studentPpsGetReply(data).then(res => {
          if(res.code == 200){
            this.list = res.result;
          }
        });
      },
    },
    beforeDestroy() {

    },
  };
  </script>

  <style lang="scss" scoped>
  .defenseSession {
    min-height: $contentH;
    padding: $sideMargin;
    padding-bottom: 0;
    .cont-box{
      background: $white;
      min-height: inherit;
      padding: 0 20px 20px;
    }
  }
  </style>
